/**
 * App Header
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import screenfull from 'screenfull';
import Tooltip from '@mui/material/Tooltip';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

// actions
import { collapsedSidebarAction } from 'Actions';

// helpers
import { getAppLayout } from "Helpers/helpers";

// components
import Notifications from './Notifications';
import ChatSidebar from './ChatSidebar';
//import DashboardOverlay from '../DashboardOverlay/DashboardOverlay';
import LanguageProvider from './LanguageProvider';
import SearchForm from './SearchForm';
import QuickLinks from './QuickLinks';
import MobileSearchForm from './MobileSearchForm';


// intl messages
import IntlMessages from 'Util/IntlMessages';

// redux action
import { logoutUserFromFirebase } from 'Actions';

class Header extends Component {

	state = {
		customizer: false,
		isMobileSearchFormVisible: false
	}

	logoutUser(e) {
		e.preventDefault();
		this.props.logoutUserFromFirebase(this.props.navigate);
	}

	// function to change the state of collapsed sidebar
	onToggleNavCollapsed = (event) => {
		const val = !this.props.navCollapsed;
		this.props.collapsedSidebarAction(val);
	}

	// open dashboard overlay
	openDashboardOverlay(e) {
		// var el = document.getElementsByClassName('dashboard-overlay')[0];
		// el.classList.toggle("d-none");
		// el.classList.toggle("show");
		// if (el.classList.contains('show')) {
		// 	document.body.style.overflow = "hidden";
		// }
		// else {
		// 	document.body.style.overflow = "";
		// }
		// e.preventDefault();
	}

	// close dashboard overlay
	closeDashboardOverlay() {
		var e = document.getElementsByClassName('dashboard-overlay')[0];
		e.classList.remove('show');
		e.classList.add('d-none');
		document.body.style.overflow = "";
	}

	// toggle screen full
	toggleScreenFull() {
		screenfull.toggle();
	}

	// mobile search form
	openMobileSearchForm() {
		this.setState({ isMobileSearchFormVisible: true });
	}

	render() {
		
		
		const { isMobileSearchFormVisible } = this.state;
		const { horizontalMenu, agencyMenu, location } = this.props;
		return (
			<AppBar position="static" className="rct-header">
				<Toolbar className="d-flex justify-content-between w-100 pl-0">
					<div className="d-inline-flex align-items-center">
						{(horizontalMenu || agencyMenu) &&
							<div className="site-logo1">
								{/* <Link to="/" className="logo-mini">
									<img src="./assets/images/tsga-logo.png" className="mr-15" alt="site logo" width="35" height="35" /> 
								</Link> */}
								<Link className="logo-normal">
									<img src={require('Assets/img/tsga-logo.png')} className="img-fluid" alt="site-logo" width="150" height="10" />
								</Link>
							</div>
						}
						{!agencyMenu &&
							<ul className="list-inline mb-0 navbar-left">
								{!horizontalMenu ?
									<li className="list-inline-item" onClick={(e) => this.onToggleNavCollapsed(e)}>
										<Tooltip title="Sidebar Toggle" placement="bottom">
											<IconButton color="inherit" mini="true" aria-label="Menu" className="humburger p-0">
												<MenuIcon />
											</IconButton>
										</Tooltip>
									</li> :
									<li className="list-inline-item">
										<Tooltip title="Sidebar Toggle" placement="bottom">
											<IconButton color="inherit" aria-label="Menu" className="humburger p-0" component={Link} to="/">
												<i className="ti-layout-sidebar-left"></i>
											</IconButton>
										</Tooltip>
									</li>
								}
								{!horizontalMenu && <QuickLinks />}
							</ul>
						}
					</div>
					<ul className="navbar-right list-inline mb-0">
						
						<li className="list-inline-item">
							<Tooltip title="Full Screen" placement="bottom">
								<IconButton aria-label="settings" onClick={() => this.toggleScreenFull()}>
									<i className="zmdi zmdi-crop-free"></i>
								</IconButton>
							</Tooltip>
						</li>
						
						<li className="list-inline-item setting-icon">
								<a href="#" onClick={(e) => this.logoutUser(e)}>
										<i className="zmdi zmdi-power text-danger mr-3"></i>
										<span style={{color:"#505971"}}><IntlMessages id="widgets.logOut" /></span>
								</a>
						</li>
						
					</ul>
					
				</Toolbar>
				{/* <DashboardOverlay
					onClose={() => this.closeDashboardOverlay()}
				/> */}
			</AppBar>
		);
	}
}

// map state to props
const mapStateToProps = ({ settings }) => {
	return settings;
};

const ConnectedHeader = connect(mapStateToProps, {
  collapsedSidebarAction,
  logoutUserFromFirebase
})(Header);

const HeaderWithRouter = (props) => {
  const navigate = useNavigate();
  return <ConnectedHeader {...props} navigate={navigate} />;
};

export default HeaderWithRouter;
